import { useState, useEffect } from "react";
import "./styles/challenge-creation.css";
import { useSelector } from "react-redux";
import moment from "moment";
//
import Logo from "../../../ui/atoms/logo/Logo";
import InputSelect from "../../../ui/atoms/inputs/input-select/InputSelect";
import InputText from "../../../ui/atoms/inputs/input-text/InputText";
import InputTextArea from "../../../ui/atoms/inputs/input-textarea/InputTextArea";
import RadioButton from "../../../ui/atoms/radio-button/RadioButton";
import RadionButton2 from "../../../ui/atoms/radio-button/RadionButton2";
import CheckBox from "../../../ui/atoms/checkbox/CheckBox";
import Button from "../../../ui/atoms/buttons/Button";
import CustomizedTextEditor from "../../../ui/organisms/customized-text-editor/CustomizedTextEditor";
import ChallengeThemeQuestionItem from "../components/challenge-theme-question-item/ChallengeThemeQuestionItem";
import PickUpQuestion from "../components/pickup-question/PickUpQuestion";
import NotFound from "../../../ui/organisms/not-found/404";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { onCreateChallenge } from "../services/challenge";
import { challengeSchema } from "../../../core/utils/validators/challenge";
import { onHandleSingleFile } from "../../../core/utils/common-validators";
import { isEmpty, convertDuration, wait } from "../../../core/utils/helpers";
//
import { PiFileAudioBold } from "react-icons/pi";
import { SlClose, SlPicture } from "react-icons/sl";
import Swal from "sweetalert2";

import useAxiosPrivate from "../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeCreation = () => {
  const axiosPrivate = useAxiosPrivate();

  const [isSending, setIsSending] = useState(false);
  const [isPickUpQuestion, setIsPickUpQuestion] = useState(false);
  const [stepFrame, setStepFrame] = useState(0);
  //
  const [challengeType, setChallengeType] = useState("classic");
  const [totalPlayers, setTotalPlayers] = useState(2);
  const [totalTeams, setTotalTeams] = useState(2);
  const [teamBreakdown, setTeamBreakdown] = useState("automatic");
  const [allowJoiningLate, setAllowJoiningLate] = useState(true);
  const [randomQuestionsOrder, setRandomQuestionsOrder] = useState(false);
  const [selfParticipation, setSelfParticipation] = useState(false);
  const [teamsDevice, setTeamsDevice] = useState("self-player-device");
  const [joiningQuestions, setJoiningQuestions] = useState(
    "from-start-question",
  );
  const [challengeJoiningAccess, setChallengeJoiningAccess] =
    useState("authorize");
  const [
    automaticallyMoveThroughQuestions,
    setAutomaticallyMoveThroughQuestions,
  ] = useState(false);
  const [stopQuestionOnFirstUserAnswer, setStopQuestionOnFirstUserAnswer] =
    useState(false);
  const [allowingNickname, setAllowingNickname] = useState(false);
  const [visibility, setVisibility] = useState("private");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minStartDate, setMinStartDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  //
  const [points, setPoints] = useState(10);
  const [timing, setTiming] = useState(10);
  const [randomAnswerOrder, setRandomAnswerOrder] = useState(false);
  const [questionDescription, setQuestionDescription] = useState("");
  const [questionExplanation, setQuestionExplanation] = useState("");
  const [questionAnswer, setQuestionAnswer] = useState("");
  const [questionAnswers, setQuestionAnswers] = useState([]);
  const [audioFile, setAudioFile] = useState(null);
  const [audioPreviewUrl, setAudioPreviewUrl] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  //
  const [questionsSet, setQuestionsSet] = useState([]);
  //
  const selectedQuestions = useSelector(
    (state) => state?.challengeState?.selectedQuestions,
  );

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );
  const _inscription_id = initConnectedUser?.inscription;

  useEffect(() => {
    const now = moment().format("YYYY-MM-DDTHH:mm");
    const datePlus24 = moment().add(24, "hours").format("YYYY-MM-DDTHH:mm");
    setStartDate(now);
    setEndDate(datePlus24);
    setMinStartDate(now);
    setMinEndDate(datePlus24);
  }, []);

  useEffect(() => {
    if (!isEmpty(selectedQuestions)) {
      for (const q of selectedQuestions) {
        setQuestionsSet((prev) => [...prev, q]);
      }
    }
  }, [selectedQuestions]);

  const {
    watch,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(challengeSchema),
  });

  const [questionType, description, ending_dates, starting_dates, title] =
    watch(["type", "description", "ending_dates", "starting_dates", "title"]);

  const removeFile = (type) => {
    if (type === "audio") {
      setAudioFile(null);
      setAudioPreviewUrl(null);
    }

    if (type === "image") {
      setImageFile(null);
      setImagePreviewUrl(null);
    }
  };

  const onAddQuestion = () => {
    if (questionType === "") {
      Swal.fire({
        title: "Question Type Not Selected",
        text: "Please select a question type before adding a question.",
        icon: "warning",
      });
      return;
    }
    if (questionDescription === "") {
      Swal.fire({
        title: "Question Description Not Provided",
        text: "Please provide a description for the question.",
        icon: "warning",
      });
      return;
    }
    if (questionExplanation === "") {
      Swal.fire({
        title: "Question Explanation Not Provided",
        text: "Please provide an explanation for the question.",
        icon: "warning",
      });
      return;
    }
    if (questionAnswers.length === 0) {
      Swal.fire({
        title: "Question Answers Not Provided",
        text: "Please provide answers for the question.",
        icon: "warning",
      });
      return;
    }
    if (!isEmpty(questionAnswers)) {
      let counter = 0;
      for (const row of questionAnswers) {
        counter = row.is_correct ? counter + 1 : counter;
      }
      if (counter === 0) {
        Swal.fire({
          title: "Question Composition Answers",
          text: `You should choose ${
            questionType === "OCA" ? "one" : "at least one"
          } right answer among answers!`,
          icon: "warning",
        });
        return false;
      }
    }
    // Add new question
    setQuestionsSet((prevState) => [
      ...prevState,
      {
        type: questionType,
        points: points,
        timing: timing,
        random_answer_order: randomAnswerOrder,
        qv_cover_audio: audioFile,
        qv_cover_image: imageFile,
        qv_description: questionDescription,
        qv_explanations: questionExplanation,
        qv_answers: questionAnswers,
      },
    ]);
    //
    onQuestionReInitializeFields();
  };

  const onRemoveQuestion = (idx) => {
    setQuestionsSet((prev) => prev.filter((_, i) => i !== idx));
  };

  const onAddAnswer = () => {
    const _questionAnswer = questionAnswer.trim();
    if (_questionAnswer === "") {
      Swal.fire({
        title: "Empty Answer Field",
        text: "Please enter an answer before push it.",
        icon: "warning",
      });
      return;
    }
    // Check if the answer already exists (case-insensitive)
    const alreadyExists = questionAnswers.some(
      (ans) =>
        ans.answer.trim().toLowerCase() === questionAnswer.trim().toLowerCase(),
    );
    if (alreadyExists) {
      Swal.fire({
        title: "Duplicate Answer",
        text: "This answer already exists. Please enter a different one.",
        icon: "error",
      });
      return;
    }
    // Add new answer
    setQuestionAnswers((prevState) => [
      ...prevState,
      {
        is_correct: false,
        answer: questionAnswer,
      },
    ]);
    // Clear input
    setQuestionAnswer("");
  };

  const onHandleRightAnswers = (idx) => {
    setQuestionAnswers((prev) =>
      questionType === "OCA"
        ? prev.map((item, i) => ({
            ...item,
            is_correct: i === idx,
          }))
        : prev.map((item, i) =>
            i === idx ? { ...item, is_correct: !item.is_correct } : item,
          ),
    );
  };

  const onRemoveAnswer = (idx) => {
    setQuestionAnswers((prev) => prev.filter((_, i) => i !== idx));
  };

  const onQuestionReInitializeFields = () => {
    setValue("type", "");
    setPoints(10);
    setTiming(10);
    setRandomAnswerOrder(false);
    setAudioFile(null);
    setAudioPreviewUrl(null);
    setImageFile(null);
    setImagePreviewUrl(null);
    setQuestionDescription("");
    setQuestionExplanation("");
    //
    setQuestionAnswers([]);
  };

  const onChallengeReInitializeFields = () => {
    reset();
    setChallengeType("classic");
    setTotalPlayers(2);
    setTotalTeams(2);
    setTeamBreakdown("automatic");
    setAllowJoiningLate(true);
    setRandomQuestionsOrder(false);
    setSelfParticipation(false);
    setJoiningQuestions("from-start-question");
    setChallengeJoiningAccess("authorize");
    setAutomaticallyMoveThroughQuestions(false);
    setStopQuestionOnFirstUserAnswer(false);
    setAllowingNickname(false);
    setVisibility("private");
    //
    setStepFrame(0);
    setQuestionsSet([]);
  };

  const onSubmit = async (data) => {
    setIsSending(true);
    Swal.fire({
      title: "Creating new Challenge...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await wait(700);
    //
    let formData = new FormData();
    //
    formData.append("dates", new Date().toISOString());
    formData.append("title", data?.title);
    formData.append("description", data?.description);
    formData.append("challenge_type", challengeType);
    formData.append("total_teams", totalTeams);
    formData.append("numbers_of_players_per_team", totalPlayers);
    formData.append("teams_breakdown", teamBreakdown);
    formData.append("allow_joining_late", allowJoiningLate ? "true" : "false");
    formData.append(
      "random_questions_order",
      randomQuestionsOrder ? "true" : "false",
    );
    formData.append("self_participation", selfParticipation ? "true" : "false");
    formData.append("teams_device", teamsDevice);
    formData.append("joining_question", joiningQuestions);
    formData.append("challenge_joining_access", challengeJoiningAccess);
    formData.append(
      "automatically_move_through_questions",
      automaticallyMoveThroughQuestions ? "true" : "false",
    );
    formData.append(
      "stop_question_on_first_user_answer",
      stopQuestionOnFirstUserAnswer ? "true" : "false",
    );
    formData.append("allowing_nickname", allowingNickname ? "true" : "false");
    formData.append("accessibility", visibility);
    formData.append("starting_dates", new Date(startDate).toISOString());
    formData.append("ending_dates", new Date(endDate).toISOString());
    formData.append("inscription_id", _inscription_id);
    //
    // Pour questionsSet, séparer fichiers et data JSON
    const questionsData = questionsSet.map((q, _) => ({
      ...q,
      qv_cover_audio: undefined,
      qv_cover_image: undefined,
    }));
    formData.append("questions", JSON.stringify(questionsData));
    //
    // Ajouter les fichiers avec un nom unique par question
    questionsSet.forEach((q, index) => {
      if (q.qv_cover_audio)
        formData.append(`qv_cover_audio_${index}`, q.qv_cover_audio);
      if (q.qv_cover_image)
        formData.append(`qv_cover_image_${index}`, q.qv_cover_image);
    });
    //
    onCreateChallenge(axiosPrivate, formData)
      .then((response) => {
        const _data = response?.data;
        Swal.close();
        setIsSending(false);
        //
        if (_data?.status) {
          Swal.fire({
            title: "Challenge Creation",
            text: _data?.message,
            icon: "success",
            confirmButtonText: "OK",
            didOpen: () => {
              const btn = Swal.getConfirmButton(); //
              btn.style.backgroundColor = "#2840a8";
              btn.style.color = "white";
            },
          });
          onChallengeReInitializeFields();
        } else {
          Swal.fire({
            title: "Challenge Creation",
            text: _data?.message,
            icon: "info",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        Swal.close();
        if (!error?.response) {
          Swal.fire({
            title: "Challenge Creation",
            text: "No server response",
            icon: "warning",
          });
        } else {
          Swal.fire({
            title: "Challenge Creation",
            text: error?.response?.data?.detail?.message,
            icon: "error",
          });
        }
      });
  };

  return (
    <div className="challenge-creation">
      <div className="challene-timeline">
        <div className="challene-timeline-head">
          <Logo to={null} width={"120px"} />
          <h1>Challenge Creation</h1>
        </div>
        <div className="challene-timeline-body">
          <div className="challene-timeline-item">
            <span
              className={
                stepFrame === 0 || stepFrame > 0
                  ? "step-mark is-activated"
                  : "step-mark"
              }
            >
              1
            </span>
            <div className="step-description">
              <h2>Initial Info</h2>
              <p>
                Provide the title and description(not mendatory) of the
                challenge
              </p>
            </div>
          </div>
          <hr />
          <div className="challene-timeline-item">
            <span
              className={
                stepFrame === 1 || stepFrame > 1
                  ? "step-mark is-activated"
                  : "step-mark"
              }
            >
              2
            </span>
            <div className="step-description">
              <h2>Configuration</h2>
              <p>Configure the challenge all specifics requirements</p>
            </div>
          </div>
          <hr />
          <div className="challene-timeline-item">
            <span
              className={
                stepFrame === 2 ? "step-mark is-activated" : "step-mark"
              }
            >
              3
            </span>
            <div className="step-description">
              <h2>Setting Questions</h2>
              <p>
                Compose or pickup from existing topics/open public assessments,
                question for your challenge
              </p>
            </div>
          </div>
        </div>
      </div>
      <form
        className="challenge-creation-wrapper p-xs"
        onSubmit={handleSubmit(onSubmit)}
      >
        {stepFrame === 0 && (
          <div className="c-c-step-1">
            <div className="w-60 mt-md">
              <div className="w-full d-flex gap-md mb-lg">
                <InputText
                  type={"text"}
                  name={"title"}
                  title={"Challenge Title"}
                  error={errors?.title?.message}
                  register={register}
                />
              </div>
              <div className="w-full d-flex">
                <InputTextArea
                  name={"description"}
                  title={"Challenge Description"}
                  error={errors?.description?.message}
                  register={register}
                />
              </div>
            </div>
            <div className="w-fit-content mt-lg mb-xs">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Next Step (Configuration) ➡️"}
                action={() => {
                  if (!title) {
                    Swal.fire({
                      title: "Missing Information",
                      text: "Please the challenge's title is a required field.",
                      icon: "warning",
                    });
                    return;
                  }
                  if (!description) {
                    Swal.fire({
                      title: "Missing Information",
                      text: "Please the challenge's description is a required field.",
                      icon: "warning",
                    });
                    return;
                  }

                  setStepFrame((prev) => prev + 1);
                }}
              />
            </div>
          </div>
        )}
        {stepFrame === 1 && (
          <div className="c-c-step-2">
            <div className="w-80 mt-md">
              <div className="w-full d-flex justify-space-between mt-md">
                <div className="w-50">
                  <h3>Challenge Mode (Type)</h3>
                  <div className="w-full d-flex gap-md mt-xs">
                    <RadionButton2
                      mode={"single"}
                      id={"classic-mode"}
                      name={"challenge-mode"}
                      value={"classic"}
                      title={"Classic Mode"}
                      checked={challengeType === "classic"}
                      onChange={(e) => {
                        setChallengeType(e?.target?.value);
                        setTotalTeams(2);
                        setTotalPlayers(2);
                      }}
                    />
                    <RadionButton2
                      mode={"team"}
                      id={"team-mode"}
                      name={"challenge-mode"}
                      value={"team"}
                      title={"Team Mode"}
                      checked={challengeType === "team"}
                      onChange={(e) => {
                        setChallengeType(e?.target?.value);
                        setTotalTeams(2);
                        setTotalPlayers(2);
                      }}
                    />
                  </div>
                </div>
                <div className="w-50">
                  <h3>Challenge Visibility in Store</h3>
                  <div className="w-full d-flex gap-md mt-xs">
                    <RadionButton2
                      mode={"private"}
                      id={"private"}
                      name={"visibility-mode"}
                      value={"private"}
                      title={"Private"}
                      checked={visibility === "private"}
                      onChange={(e) => setVisibility(e?.target?.value)}
                    />
                    <RadionButton2
                      mode={"public"}
                      id={"public"}
                      name={"visibility-mode"}
                      value={"public"}
                      title={"Public"}
                      checked={visibility === "public"}
                      onChange={(e) => setVisibility(e?.target?.value)}
                    />
                  </div>
                </div>
              </div>
              {challengeType === "team" && (
                <div className="w-full mt-md timing-wrapper fade-in">
                  <span>Challenge Total Teams</span>
                  <div className="w-full d-flex align-center gap-xs">
                    <input
                      className="w-90"
                      type="range"
                      name="points"
                      id="points"
                      min={2}
                      max={10}
                      step={1}
                      value={totalTeams}
                      onChange={(e) => setTotalTeams(e.target.value)}
                    />
                    <output htmlFor="timing">{totalTeams} Teams</output>
                  </div>
                </div>
              )}
              <div className="w-full mt-md timing-wrapper">
                <span>Challenge Total Players</span>
                <div className="w-full d-flex align-center gap-xs">
                  <input
                    className="w-90"
                    type="range"
                    name="points"
                    id="points"
                    min={2}
                    max={challengeType === "team" ? 5 : 50}
                    step={1}
                    value={totalPlayers}
                    onChange={(e) => setTotalPlayers(e.target.value)}
                  />
                  <output htmlFor="timing">{totalPlayers} Players</output>
                </div>
              </div>
              {challengeType === "team" && (
                <div className="w-full mt-md">
                  <h3>Challenge Team Breakdown Mode</h3>
                  <div className="w-full">
                    <InputSelect
                      name={"teams-mode"}
                      placeholder={"Select Team Breakdown Mode"}
                      data={[
                        {
                          key: "automatic",
                          title:
                            "Automatic (Players are automatically assigned to teams)",
                          is_activated: false,
                        },
                        {
                          key: "self-managed",
                          title:
                            "Self-Manage (The host assigned the players to their teams)",
                          is_activated: false,
                        },
                        {
                          key: "self-choice",
                          title: "Self-Choice (Players choose their teams)",
                          is_activated: false,
                        },
                      ]}
                      value={teamBreakdown}
                      onChange={(e) => setTeamBreakdown(e?.target?.value)}
                    />
                  </div>
                </div>
              )}
              <div className="w-full d-flex justify-space-between gap-lg mt-md">
                <div className="w-fit-content d-flex align-center gap-md">
                  <h3>Challenge Allow Joining late</h3>
                  <CheckBox
                    id={"allow-joining-late"}
                    checked={allowJoiningLate}
                    onChange={(e) => setAllowJoiningLate(e?.target?.checked)}
                  />
                </div>
                <div className="w-fit-content d-flex align-center gap-md">
                  <h3>Random Order of Questions ?</h3>
                  <CheckBox
                    id={"random-questions-order"}
                    checked={randomQuestionsOrder}
                    onChange={(e) =>
                      setRandomQuestionsOrder(e?.target?.checked)
                    }
                  />
                </div>
                <div className="w-fit-content d-flex align-center gap-md">
                  <h3>Self Participation ?</h3>
                  <CheckBox
                    id={"self-participation"}
                    checked={selfParticipation}
                    onChange={(e) => setSelfParticipation(e?.target?.checked)}
                  />
                </div>
              </div>
              <div className="w-full d-flex justify-space-between mt-md">
                {teamBreakdown === "self-managed" && (
                  <div className="w-fit-content">
                    <h3>Team Device's Usage</h3>
                    <div className="w-full d-flex gap-md mt-xs">
                      <RadionButton2
                        mode={"breakdown"}
                        id={"self-player-device"}
                        name={"teams_device"}
                        value={"self-player-device"}
                        title={"Self Player Device"}
                        checked={teamsDevice === "self-player-device"}
                        onChange={(e) => setTeamsDevice(e?.target?.value)}
                      />
                      <RadionButton2
                        mode={"breakdown"}
                        id={"shared-team-device"}
                        name={"teams_device"}
                        value={"shared-team-device"}
                        title={"Shared Team's Device"}
                        checked={teamsDevice === "shared-team-device"}
                        onChange={(e) => setTeamsDevice(e?.target?.value)}
                      />
                    </div>
                  </div>
                )}
                <div className="w-fit-content">
                  <h3>Challenge Joining Questions Mode</h3>
                  <div className="w-full d-flex gap-md mt-xs">
                    <RadionButton2
                      mode={"question"}
                      id={"question-start-mode"}
                      name={"questions-mode"}
                      value={"from-start-question"}
                      title={"From Start Question"}
                      checked={joiningQuestions === "from-start-question"}
                      onChange={(e) => setJoiningQuestions(e?.target?.value)}
                    />
                    <RadionButton2
                      mode={"question"}
                      id={"current-question-mode"}
                      name={"questions-mode"}
                      value={"from-current-question"}
                      title={"From Current Question"}
                      checked={joiningQuestions === "from-current-question"}
                      onChange={(e) => setJoiningQuestions(e?.target?.value)}
                    />
                  </div>
                </div>
                <div className="w-fit-content">
                  <h3>Challenge Joining Access Mode</h3>
                  <div className="w-full d-flex gap-md mt-xs">
                    <RadionButton2
                      mode={"unlocked"}
                      id={"automatic-mode"}
                      name={"joining-mode"}
                      value={"automatic"}
                      title={"Automatic"}
                      checked={challengeJoiningAccess === "automatic"}
                      onChange={(e) =>
                        setChallengeJoiningAccess(e?.target?.value)
                      }
                    />
                    <RadionButton2
                      mode={"locked"}
                      id={"authorize-mode"}
                      name={"joining-mode"}
                      value={"authorize"}
                      title={"Authorize"}
                      checked={challengeJoiningAccess === "authorize"}
                      onChange={(e) =>
                        setChallengeJoiningAccess(e?.target?.value)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="w-full d-flex justify-space-between gap-md mt-lg">
                <div className="w-fit-content d-flex align-center gap-md">
                  <h3>Automatically move through questions</h3>
                  <CheckBox
                    id={"automatically_move_through_questions"}
                    checked={automaticallyMoveThroughQuestions}
                    onChange={(e) =>
                      setAutomaticallyMoveThroughQuestions(e?.target?.checked)
                    }
                  />
                </div>
                <div className="w-fit-content d-flex align-center gap-md">
                  <h3>Stop Question on first Player answered</h3>
                  <CheckBox
                    id={"stop_question_on_first_user_answer"}
                    checked={stopQuestionOnFirstUserAnswer}
                    onChange={(e) =>
                      setStopQuestionOnFirstUserAnswer(e?.target?.checked)
                    }
                  />
                </div>
                <div className="w-fit-content d-flex align-center gap-md">
                  <h3>Allowing Nickname</h3>
                  <CheckBox
                    id={"allowing_nickname"}
                    checked={allowingNickname}
                    onChange={(e) => setAllowingNickname(e?.target?.checked)}
                  />
                </div>
              </div>
              <div className="w-full d-flex justify-space-between gap-md mt-lg">
                <div className="w-50">
                  <h3>Starting Date</h3>
                  <InputText
                    type={"datetime-local"}
                    name={"starting_dates"}
                    title={"Start"}
                    error={errors?.starting_dates?.message}
                    register={register}
                    value={startDate}
                    min={minStartDate}
                  />
                </div>
                <div className="w-50">
                  <h3>Ending Date</h3>
                  <InputText
                    type={"datetime-local"}
                    name={"ending_dates"}
                    title={"End"}
                    error={errors?.ending_dates?.message}
                    register={register}
                    value={endDate}
                    min={minEndDate}
                  />
                </div>
              </div>
            </div>
            <div className="w-80 d-flex justify-space-between align-center pt-lg pb-xs">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"⬅️ Previous Step"}
                action={() => setStepFrame((prev) => prev - 1)}
              />
              <Button
                type={"button"}
                preferedStyle={"normal"}
                title={"Next Step (Questions Composition) ➡️"}
                action={() => {
                  if (!starting_dates) {
                    Swal.fire({
                      title: "Missing Information",
                      text: "Please the starting date of challenge is a required field.",
                      icon: "warning",
                    });
                    return;
                  }
                  if (!ending_dates) {
                    Swal.fire({
                      title: "Missing Information",
                      text: "Please the ending date of challenge is a required field.",
                      icon: "warning",
                    });
                    return;
                  }

                  setStepFrame((prev) => prev + 1);
                }}
              />
            </div>
          </div>
        )}
        {stepFrame === 2 && (
          <div className="c-c-step-3">
            <div className="w-full d-flex justify-space-between c-c-step-3-head">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"⬅️ Previous Step (Configuration)"}
                action={() => setStepFrame((prev) => prev - 1)}
              />
              <div className="w-fit-content d-flex gap-md">
                <Button
                  type={"button"}
                  preferedStyle={"normal"}
                  title={"🏬 Pick up Questions from Store"}
                  action={() => setIsPickUpQuestion(true)}
                />
                {questionsSet.length > 0 && (
                  <Button
                    type={"submit"}
                    preferedStyle={"validate"}
                    title={
                      isSending
                        ? "Creating Challenge..."
                        : "✅ Create Challenge"
                    }
                    action={() => {}}
                  />
                )}
              </div>
            </div>
            <div className="w-full d-flex gap-md c-c-step-3-body">
              <div className="w-40">
                <div className="w-full mb-lg">
                  <InputSelect
                    name={"type"}
                    error={errors?.type?.message}
                    register={register}
                    data={[
                      {
                        key: "OCA",
                        title: "One Choice Answer",
                        is_activated: false,
                      },
                      {
                        key: "MCA",
                        title: "Multi Choices Answer",
                        is_activated: false,
                      },
                    ]}
                    placeholder={"Question Type(Answer's Type)"}
                  />
                </div>
                <div className="w-full d-flex justify-space-between gap-md mb-md">
                  <div className="w-50 timing-wrapper">
                    <span>Question Total Points</span>
                    <div className="w-full d-flex align-center gap-xs">
                      <input
                        className="w-60"
                        type="range"
                        name="points"
                        id="points"
                        min={10}
                        max={30}
                        step={1}
                        value={points}
                        onChange={(e) => setPoints(e.target.value)}
                      />
                      <output htmlFor="timing">{points} Points</output>
                    </div>
                  </div>
                  <div className="w-50 timing-wrapper">
                    <span>Question Timing</span>
                    <div className="w-full d-flex align-center gap-xs">
                      <input
                        className="w-60"
                        type="range"
                        name="timing"
                        id="timing"
                        min={10}
                        max={1800}
                        step={1}
                        value={timing}
                        onChange={(e) => setTiming(e.target.value)}
                      />
                      <output htmlFor="timing">
                        {convertDuration(timing)}
                      </output>
                    </div>
                  </div>
                </div>
                <div className="w-full d-flex align-center gap-md mb-md">
                  <span>Random Order of Answers ?</span>
                  <CheckBox
                    id={"random-answer-order"}
                    checked={randomAnswerOrder}
                    onChange={(e) => setRandomAnswerOrder(e?.target?.checked)}
                  />
                </div>
                {/* Audio process */}
                <div className="w-full mb-lg">
                  <div className="browse-image">
                    <input
                      type="file"
                      id="audio_input"
                      accept="audio/mpeg,audio/wav,audio/mp3"
                      onChange={(e) => {
                        const _audioFile = onHandleSingleFile(e);
                        if (
                          !_audioFile ||
                          !_audioFile.type.startsWith("audio/")
                        )
                          return;

                        setAudioFile(_audioFile);
                        //   Create a temporary URL for the selected fil
                        const newPreviewUrl = URL.createObjectURL(_audioFile);
                        setAudioPreviewUrl(newPreviewUrl);
                      }}
                    />
                    <label htmlFor="audio_input">
                      <PiFileAudioBold className="icon" />
                      <span>Load Audio</span>
                    </label>
                  </div>
                  {audioPreviewUrl && (
                    <div className="files-container">
                      <div className="file-item file-item-audio">
                        <span className="file-icon">
                          <PiFileAudioBold className="icon" />
                        </span>
                        <div className="file-description">
                          <audio
                            className="w-full"
                            controls
                            controlsList="nodownload"
                            onContextMenu={(e) => e.preventDefault()}
                          >
                            <source
                              src={audioPreviewUrl}
                              type={audioFile?.type}
                            />
                          </audio>
                        </div>
                        <span
                          className="file-action"
                          onClick={() => removeFile("audio")}
                        >
                          <SlClose className="icon" />
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                {/* Image process */}
                <div className="w-full mb-lg">
                  <div className="browse-image">
                    <input
                      type="file"
                      id="image_input"
                      accept="image/*"
                      onChange={(e) => {
                        const _imageFile = onHandleSingleFile(e);
                        if (
                          !_imageFile ||
                          !_imageFile.type.startsWith("image/")
                        )
                          return;

                        setImageFile(_imageFile);
                        //   Create a temporary URL for the selected fil
                        const newPreviewUrl = URL.createObjectURL(_imageFile);
                        setImagePreviewUrl(newPreviewUrl);
                      }}
                    />
                    <label htmlFor="image_input">
                      <SlPicture className="icon" />
                      <span>Load Illustrative Image</span>
                    </label>
                  </div>
                  {imagePreviewUrl && (
                    <div className="files-container">
                      <div className="file-item file-item-image">
                        <div className="file-description">
                          <img
                            src={imagePreviewUrl}
                            alt="cover illustration Preview"
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </div>
                        <span
                          className="file-action"
                          onClick={() => removeFile("image")}
                        >
                          <SlClose className="icon" />
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                {/*  */}
                <div className="w-full content-wrapper">
                  <span>Question Description</span>
                  <hr />
                  <CustomizedTextEditor
                    content={questionDescription}
                    setContent={setQuestionDescription}
                  />
                </div>
                <div className="w-full content-wrapper">
                  <span>Explanations Description</span>
                  <hr />
                  <CustomizedTextEditor
                    content={questionExplanation}
                    setContent={setQuestionExplanation}
                  />
                </div>
                <div className="w-full content-wrapper">
                  <span>Answers</span>
                  <hr />
                  <div className="answers-wrapper">
                    {isEmpty(questionAnswers) ? (
                      <p
                        style={{
                          color: "brown",
                          fontSize: "1rem",
                          fontStyle: "italic",
                        }}
                      >
                        Waiting for answers to be setup!
                      </p>
                    ) : (
                      questionAnswers?.map((row, idx) => (
                        <div className="answer-item" key={idx}>
                          {!isEmpty(questionType) && (
                            <div className="w-full d-flex justify-space-between align-center">
                              {questionType === "OCA" ? (
                                <RadioButton
                                  id={`answer-option-${idx}`}
                                  name={`answer-option-${idx}`}
                                  title={"is the Right One ?"}
                                  checked={row.is_correct}
                                  onChange={() => onHandleRightAnswers(idx)}
                                />
                              ) : (
                                <CheckBox
                                  id={`answer-option-${idx}`}
                                  title={"is the Right One ?"}
                                  checked={row.is_correct}
                                  onChange={() => onHandleRightAnswers(idx)}
                                />
                              )}
                              <SlClose
                                className="icon"
                                onClick={() => onRemoveAnswer(idx)}
                              />
                            </div>
                          )}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: row?.answer,
                            }}
                          />
                        </div>
                      ))
                    )}
                  </div>
                  <CustomizedTextEditor
                    content={questionAnswer}
                    setContent={setQuestionAnswer}
                  />
                  <div className="w-full d-flex justify-center align-center gap-md mt-md">
                    <Button
                      type={"button"}
                      preferedStyle={"default"}
                      title={"Add answer"}
                      action={() => onAddAnswer()}
                    />
                    <Button
                      type={"button"}
                      preferedStyle={"normal"}
                      title={"Validate Question"}
                      action={onAddQuestion}
                    />
                  </div>
                </div>
              </div>
              <div className="w-60">
                {isEmpty(questionsSet) ? (
                  <NotFound
                    type={"data"}
                    title={"No Question Composed yet!!"}
                    text={"Waiting for questions to be composed...!"}
                    isBoutton={false}
                  />
                ) : (
                  questionsSet.map((question, idx) => (
                    <ChallengeThemeQuestionItem
                      key={idx}
                      index={idx + 1}
                      question_data={question}
                      isActionsButton={false}
                      isDisplayLanguage={false}
                      isCheckBox={false}
                      isRemoveButton={true}
                      removeFunction={() => onRemoveQuestion(idx)}
                    />
                  ))
                )}
              </div>
            </div>
          </div>
        )}
      </form>
      {isPickUpQuestion && (
        <div className="pickup-frame-container">
          <PickUpQuestion setIsPickUpQuestion={setIsPickUpQuestion} />
        </div>
      )}
    </div>
  );
};

export default ChallengeCreation;
